import { Campaign } from './campaign';
import { Address, IUsername } from './user';

export interface UserContact {
  phone: string | null;
  email?: string;
  address: Address;
  fax?: string | null;
}

export enum OrganizationRole {
  ADMIN = 'ADMIN',
  DELEGATE = 'DELEGATE', // Org Default Delegate
  CLINICIAN = 'CLINICIAN', // Clinician with NPI
}

export interface IClinic {
  name: string;
  clinic_id: string;
  can_order?: boolean;
  roles: OrganizationRole[];
  phone?: string | null;
  address?: Address | null;
  fax?: string | null;
  fax_number_verified?: boolean;
  is_fax_enabled?: boolean;
}

export interface Clinician {
  name: IUsername;
  clinic_name: string;
  clinician_id?: string;
  contact_info?: UserContact[];
  campaigns?: Campaign[];
  organizational_roles?: OrganizationRole[];
  npi: string;
  clinics: IClinic[];
  is_active?: boolean;
}

export enum Sex {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export interface ICommunicationPreference {
  receives_results_email: boolean;
}

export interface IExtendedClinician extends Clinician {
  label: string;
  email: string;
  roles: string;
  communication_preferences: ICommunicationPreference;
  license_status?: 'UNVERIFIED' | 'VERIFIED' | 'REVOKED';
}

export interface IClinicianOption extends Clinician {
  label: string;
  id: string;
}
